/**
 * Appends the underline SVG for the current word.
 * @param {Document} frameDocument - iframe document
 * @param {Object} wordObject - word object for current word offset which was calculated in bookDocumentInformation.#processWord
 */
const appendSvg = (frameDocument, wordObject) => {
  // create and style the SVG element
  const svgElement = frameDocument.createElementNS(
    'http://www.w3.org/2000/svg',
    'svg',
  );

  svgElement.setAttribute('width', wordObject.rangeRectangle.width);
  svgElement.setAttribute('height', '2');
  svgElement.classList.add('tts-underline');
  svgElement.style.top = `${
    wordObject.rangeRectangle.top + wordObject.rangeRectangle.height
  }px`;
  svgElement.style.left = `${wordObject.rangeRectangle.left}px`;

  // create and style the rect element
  const rectElement = frameDocument.createElementNS(
    'http://www.w3.org/2000/svg',
    'rect',
  );
  rectElement.setAttribute('width', wordObject.rangeRectangle.width);
  rectElement.setAttribute('height', '2');

  svgElement.appendChild(rectElement);

  frameDocument.body.parentElement.appendChild(svgElement);
};

export default appendSvg;
